export default __webpack_public_path__ + "static/media/refresh_s.e37151f1.svg";